import FabricOrderType from "./actionTypes"

const INIT_STATE = {
  pageData: {
    loading: true,
    data: {}
  },
  detail: {
    loading: false,
    data: {}
  },
  saved: {
    loading: false
  },
  list: {
    loading: true,
    data: []
  },
  number: {
    loading: true,
    data: []
  },
  customer: {
    loading: true,
    data: []
  },
  bunch: {
    loading: true,
    data: []
  },
  brand: {
    loading: true,
    data: []
  }
}

const FabricOrder = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FabricOrderType.GET_FABRIC_ORDER_PAGES_SUCCESS:
      return {
        ...state,
        pageData: action.payload,
      }

    case FabricOrderType.GET_DETAIL_FABRIC_ORDER_BY_ID_SUCCESS:
      return {
        ...state,
        detail: action.payload,
      }

    case FabricOrderType.PUT_FABRIC_ORDER_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }

    case FabricOrderType.POST_FABRIC_ORDER_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }

    case FabricOrderType.GET_FABRIC_ORDER_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      }
    case FabricOrderType.GET_FABRIC_NUMBER_LIST_SUCCESS:
      return {
        ...state,
        number: action.payload,
      }
    case FabricOrderType.GET_FABRIC_CUSTOMER_NAME_LIST_SUCCESS:
      return {
        ...state,
        customer: action.payload,
      }
    case FabricOrderType.GET_FABRIC_BUNCH_LIST_SUCCESS:
      return {
        ...state,
        bunch: action.payload,
      }
    case FabricOrderType.GET_FABRIC_BRAND_LIST_SUCCESS:
      return {
        ...state,
        brand: action.payload,
      }

    default:
      return state
  }
}

export default FabricOrder
